import{ FiCheck, FiUserPlus } from'react-icons/fi'


export const SingleRequest = () =>{

    return (
        <div className="frame mb-3 shadow-sm friendship">
                <h3 className="frame-title">Requests</h3>
                <div className="">
                    <div className="introduce flex-start">
                        <img src="/assets/images/faces/8.png" alt="" />
                        <div>
                            <h5>Sophia Lee</h5>
                            <p>Photographer at photography</p>
                        </div>
                    </div>
                    <div className="friends flex-start">
                        <div className="overlapping-avatars">
                            <img src="/assets/images/faces/1.png" alt="" />
                            <img src="/assets/images/faces/2.png" alt="" />
                            <img src="/assets/images/faces/3.png" alt="" />
                            <img src="/assets/images/faces/4.png" alt="" />
                        </div>
                        <p className="">4 mutual friends</p>
                        
                    </div>
                
                    <div className="actions flex">
                        <a className="flex-center"><FiCheck /> <p>Accept</p></a>
                        <a className="flex-center"> <FiUserPlus /> <p>Follow</p> </a>
                    </div>
                    

                </div>
            </div>
    )
} 